import { SxProps, Theme } from "@mui/material";

export const dialogPaperSx: SxProps<Theme> = {
  borderRadius: 3,
  background: '#1e1f25',
  maxWidth: "520px !important",
  border: '1px solid #354eef',
};

export const buttonSx = {
  py: 1.5,
  borderRadius: 2,
  fontSize: '1rem',
  fontWeight: 700,
  textTransform: 'none',
  background: '#354EEF',
  color: '#FFFFFF',
  '&:hover': {
    background: '#354eef',
  },
  '&:disabled': {
    background: 'rgba(255, 255, 255, 0.1)',
    color: 'rgba(255, 255, 255, 0.3)',
  }
};

export const codeInputSx = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    borderRadius: 2,
    fontSize: '2rem',
    fontWeight: 700,
    letterSpacing: '1.2rem',
    '& fieldset': {
      borderColor: 'rgba(102, 126, 234, 0.3)',
      borderWidth: 2,
    },
    '&:hover fieldset': {
      borderColor: '#354eef',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#354eef',
    },
    '& input': {
      textAlign: 'center',
      color: '#fff',
      padding: '18px',
    },
  },
};

/** Wider variant for dual-method dialog (no maxWidth constraint) */
export const dialogPaperWideSx: SxProps<Theme> = {
  borderRadius: 3,
  background: '#1e1f25',
  border: '1px solid #354eef',
};

export const successGradientButtonSx = {
  ...buttonSx,
  background: 'linear-gradient(45deg, #6366f1, #818cf8)',
  '&:hover': {
    background: 'linear-gradient(45deg, #4f46e5, #6366f1)',
  },
};
